import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { setCredentials, logOut } from '../../features/auth/authSlice'

const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL || 'http://localhost:3001',
    credentials: 'include',
    prepareHeaders: (headers, { getState }) => {
        const token = getState().auth.token;
        if (token) {
            headers.set("authorization", `Bearer ${token}`);
        }
        return headers;
    }
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
    // console.log(args) // request url, method, body
    // console.log(api) // signal, dispatch, getState()
    // console.log(extraOptions) //custom like {shout: true}

    let result = await baseQuery(args, api, extraOptions)

    const status = result?.error?.status
    const message = String(result?.error?.data?.message ?? '')
    const messageLower = message.toLowerCase()
    const requestUrl = typeof args === 'string' ? args : args?.url
    const isAuthRequest =
        typeof requestUrl === 'string' &&
        (requestUrl.startsWith('/auth') || requestUrl.startsWith('auth/'))

    // Only refresh/retry for auth failures. Plain 403 "access denied" from the API must not
    // trigger refresh + logout (same status is used for permission/ownership rules).
    const looksLikeAccessTokenProblem =
        status === 401 ||
        (status === 403 &&
            (messageLower.includes('jwt invalid') || messageLower.includes('invalid token structure')))

    // Attempt refresh only for protected-resource failures (avoid auth endpoints like /auth login itself)
    if (!isAuthRequest && looksLikeAccessTokenProblem) {
        // console.log('sending refresh token')

        // send refresh token to get new access token 
        const refreshResult = await baseQuery('/auth/refresh', api, extraOptions)

        if (refreshResult?.data) {

            // store the new token 
            api.dispatch(setCredentials({ ...refreshResult.data }))

            // retry original query with new access token
            result = await baseQuery(args, api, extraOptions)
        } else {
            // On refresh failure, force logout
            api.dispatch(logOut())
            if (refreshResult?.error?.status === 403 && refreshResult?.error?.data) {
                refreshResult.error.data.message = "Your login has expired. "
            }
            return refreshResult
        }
    }

    return result
}

export const apiSlice = createApi({
    baseQuery: baseQueryWithReauth,
    tagTypes: ['Renergy', 'User', 'Inventory', 'InventoryList', 'InventoryListSummary', 'Blog', 'Request', 'Settings', 'Affiliation', 'SolarCalculatorRating', 'SolarCalculatorActivityLog', 'UserAssessmentQueue'],
    endpoints: builder => ({})
})